module.exports = __webpack_public_path__ + "img/sShkBoomX2_193x205.2b778196.png";